import { useMemo, useState } from 'react'
import { tsToDate, chipStyle } from '../lib/format.js'
import { Calendar } from '../ds/index.js'

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

export default function EngagementCalendarView({ engagements, usersById, onOpen, month }) {
  const [displayed, setDisplayed] = useState(() => month || new Date())

  const year = displayed.getFullYear()
  const monthIndex = displayed.getMonth()

  const { leadingBlanks, dayCount } = useMemo(() => {
    const firstOfMonth = new Date(year, monthIndex, 1)
    const lastOfMonth = new Date(year, monthIndex + 1, 0)
    return { leadingBlanks: firstOfMonth.getDay(), dayCount: lastOfMonth.getDate() }
  }, [year, monthIndex])

  const engagementsByDay = useMemo(() => {
    const map = {}
    for (const e of engagements) {
      const d = tsToDate(e.date)
      if (!d) continue
      if (d.getFullYear() !== year || d.getMonth() !== monthIndex) continue
      const day = d.getDate()
      if (!map[day]) map[day] = []
      map[day].push(e)
    }
    return map
  }, [engagements, year, monthIndex])

  const goPrev = () => setDisplayed((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1))
  const goNext = () => setDisplayed((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1))

  const days = Array.from({ length: dayCount }, (_, i) => {
    const dayNum = i + 1
    const dayEngagements = engagementsByDay[dayNum] || []
    return {
      key: dayNum,
      label: dayNum,
      empty: dayEngagements.length === 0,
      events: dayEngagements.map((e) => (
        <button
          key={e.id}
          onClick={() => onOpen(e.id)}
          title={e.title}
          style={{
            ...chipStyle('var(--color-gold)'),
            cursor: 'pointer',
            width: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textTransform: 'none',
            letterSpacing: 0,
            textAlign: 'left',
          }}
        >
          {e.title}
        </button>
      )),
    }
  })

  return (
    <div>
      <Calendar
        title={`${MONTH_NAMES[monthIndex]} ${year}`}
        onPrev={goPrev}
        onNext={goNext}
        leadingBlanks={leadingBlanks}
        days={days}
      />
    </div>
  )
}
